import { render } from "./RightClickDeviceMenu.vue?vue&type=template&id=d2fddf6a&scoped=true"
import script from "./RightClickDeviceMenu.vue?vue&type=script&lang=js"
export * from "./RightClickDeviceMenu.vue?vue&type=script&lang=js"

import "./RightClickDeviceMenu.vue?vue&type=style&index=0&id=d2fddf6a&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2fddf6a"]])

export default __exports__